import CloseIcon from "@mui/icons-material/Close";
import ReplyIcon from "@mui/icons-material/Reply";
import { Box, IconButton } from "@mui/material";

import { Text } from "../../components/Text";

interface ChatReplyPreviewProps {
  message: string;
  senderName: string;
  onCancel: () => void;
}

/**
 * Display a preview of the message being replied to.
 * Shows above the chat input when replying.
 */
export function ChatReplyPreview(props: ChatReplyPreviewProps) {
  const { message, senderName, onCancel } = props;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: 3,
        backgroundColor: theme.palette.background.default,
        borderLeft: `3px solid ${theme.palette.primary.main}`,
      })}
    >
      {/* Reply icon */}
      <ReplyIcon
        sx={(theme) => ({
          fontSize: "18px",
          color: theme.palette.primary.main,
        })}
      />

      {/* Reply content */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Text
          semibold
          variant="caption"
          sx={(theme) => ({
            color: theme.palette.primary.main,
          })}
        >
          Replying to {senderName}
        </Text>
        <Text
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          })}
        >
          {message}
        </Text>
      </Box>

      {/* Cancel button */}
      <IconButton
        aria-label="Cancel reply"
        size="small"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
          "&:hover": {
            color: theme.palette.text.primary,
          },
        })}
        onClick={onCancel}
      >
        <CloseIcon sx={{ fontSize: "18px" }} />
      </IconButton>
    </Box>
  );
}
